<a (click)="redirect()" [ngClass]="getCssClass()" id="pending-order-btn">
  <div class="text-wrapper">
    <p>We need your authorisation to proceed with your order</p>
    <span *ngIf="!hasAwaitingAuthorisations">Please review</span>
  </div>
  <div *ngIf="!hasAwaitingAuthorisations" class="icon arrow-right-red" id="arrow-red"></div>
  <div *ngIf="hasAwaitingAuthorisations" class="icon arrow-right-grey-47454b" id="arrow-grey"></div>
</a>
